import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import easyLogin from '../views/easyLogin.vue'
import store from '@/store'
import {
  Modal,
  message
} from 'ant-design-vue';
Vue.use(VueRouter)

import util from "@/utils/util";
import { sensorsAnalytics, moduleStayTime } from "@/request/api";



export const routes = [{
  path: '/login',
  name: 'Login',
  component: Login,
  meta: {
    requireAuth: false
  }
},
{
  path: '/',
  name: 'Home',
  component: Home,
  redirect: '/Dashboard',
  meta: {
    requireAuth: true,
    parent: 'Home'
  },
  children: [{
    path: '/Dashboard',
    name: '首页',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      requireAuth: true,
      parent: 'Home',
      icon: 'home',
      parentName: 'Home',
      show: true
    }
  },
  //用餐人员管理
  {
    path: '/dinnersManage',
    name: '人员管理',
    component: () => import('@/views/CommonSeconRouerview.vue'),
    meta: {
      requireAuth: true,
      parent: '人员管理',
      icon: "team",
      show: true,
    },
    children: [{
      path: '/DepartmentSet',
      name: '部门设置',
      component: () => import('@/views/office/index.vue'),
      meta: {
        authority: 'b.office.datagrid',
        parent: '人员管理',
      }
    },
    {
      path: '/JobSet',
      name: '职务设置',
      component: () => import('@/views/post/index.vue'),
      meta: {
        parent: '人员管理',
        enterAuth: true,
        authority: 'b.post.datagrid',
      }
    },
    {
      path: '/PersonInfoManage',
      name: '人员管理',
      component: () => import('@/views/dinnersManage/PersonInfoManage.vue'),
      meta: {
        requireAuth: true,
        parent: '人员管理',
        enterAuth: true,
        authority: 'b.sub_user.datagrid',
      }
    },
    {
      path: '/NotAuditList',
      name: '免审核名单',
      component: () => import('@/views/dinnersManage/NotAuditList.vue'),
      meta: {
        requireAuth: true,
        parent: '人员管理',
        enterAuth: true,
        authority: 'b.whitelist.datagrid',
      }
    },
    {
      path: '/AdministratorAssignment',
      name: '子管理员',
      component: () => import('@/views/institutionsManage/AdministratorAssignment.vue'),
      meta: {
        requireAuth: true,
        parent: '人员管理',
        enterAuth: true,
        authority: 'b.staff.datagrid',
      }
    },
      /*
      {
        path: '/AddDinner',
        name: '添加用餐人员',
        component: () => import('@/views/dinnersManage/AddDinner.vue'),
        meta: {
          requireAuth: true,
          parent: '用餐人员管理',
          enterAuth: true,
  
        }
      },*/
    ]
  },

  //用餐管理设置模块
  {
    path: '/mealsManage',
    name: '用餐管理',
    component: () => import('@/views/CommonSeconRouerview.vue'),
    meta: {
      requireAuth: true,
      parent: '用餐管理',
      icon: "coffee",
      show: true
    },
    children: [{
      path: '/OpenDinnerDate',
      name: '开餐日期',
      component: () => import('@/views/suspension/index.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.canteen_config.edit'
      }
    }, {
      path: '/MealTiming',
      name: '用餐时段',
      component: () => import('@/views/meal/index.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.meal.datagrid'
      }
    },/*{
      path: '/BatchMealTiming',
      name: '用餐时段设置',
      component: () => import('@/views/mealsManage/BatchMealTiming.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
      }
    }, */{
      path: '/CoursesStorage',
      name: '菜品库',
      component: () => import('@/views/mealsManage/CoursesStorage.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.menu.datagrid'
      }
    }, {
      path: '/EveryDayMenu',
      name: '每日菜谱',
      component: () => import('@/views/mealsManage/EveryDayMenu.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.daily_menu.datagrid'
      }
    },
    {
      path: '/MealDetail',
      name: '报餐明细',
      component: () => import('@/views/mealsManage/MealDetail.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.order.datagrid'
      }
    }, {
      path: '/MealStatistics',
      name: '报餐统计',
      component: () => import('@/views/mealsManage/MealStatistics.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.order.statistic'
      }
    },{
      path: '/Batching',
      name: '原料管理',
      component: () => import('@/views/batching/batching.vue'),
      meta: {
        requireAuth: true,
        parent: '原料管理',
        enterAuth: true,
        authority: 'b.batching.datagrid'
      }
    },
    
      {
        path: '/BatchingReport',
        name: '原料统计',
        component: () => import('@/views/batching/batchingReport.vue'),
        meta: {
          requireAuth: true,
          parent: '原料统计',
          enterAuth: true,
          authority: 'b.batching.datagrid'
        }
      },
    {
      path: '/EstimateList',
      name: '评论列表',
      component: () => import('@/views/mealsManage/EstimateList.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.order_evaluation.datagrid'
      }
    }, {
      path: '/AntistopList',
      name: '关键词列表',
      component: () => import('@/views/mealsManage/AntistopList.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.antistop.datagrid'
      }
    },
    {
      path: '/SceneOrder',
      name: '现场点餐',
      component: () => import('@/views/mealsManage/SceneOrder.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.outer_order.datagrid'
      }
    }
    ]
  },

  //客餐管理设置模块
  {
    path: '/GuestMealManage',
    name: '客餐/接待餐',
    component: () => import('@/views/CommonSeconRouerview.vue'),
    meta: {
      requireAuth: true,
      parent: '客餐/接待餐',
      icon: "container",
      show: true
    },
    children: [{
      path: '/GuestMealManage',
      name: '客餐管理',
      component: () => import('@/views/guestMeal/index.vue'),
      meta: {
        requireAuth: true,
        parent: '客餐管理',
        enterAuth: true,
        authority: 'b.guest_meal_manage.datagrid'
      }
    }, {
      path: '/GuestMealOrder',
      name: '客餐记录',
      component: () => import('@/views/guestMeal/order.vue'),
      meta: {
        requireAuth: true,
        parent: '客餐记录',
        enterAuth: true,
        authority: 'b.guest_meal_order.datagrid'
      }
    }, {
      path: '/GuestMealOrderStat',
      name: '客餐统计',
      component: () => import('@/views/guestMeal/stat.vue'),
      meta: {
        requireAuth: true,
        parent: '客餐统计',
        enterAuth: true,
        authority: 'b.guest_meal_order_stat'
      }
    },
    ]
  },

  //用餐管理设置模块
  {
    path: '/mealsManage',
    name: '消费码&小卖部',
    component: () => import('@/views/CommonSeconRouerview.vue'),
    meta: {
      requireAuth: true,
      parent: '消费码&小卖部',
      icon: "shop",
      show: true
    },
    children: [{
      path: '/ShopGoodsManage',
      name: '小卖部商品管理',
      component: () => import('@/views/mealsManage/ShopGoodsManage.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.goods.datagrid'
      }
    }, {
      path: '/ShopOrdersManage',
      name: '小卖部订单管理',
      component: () => import('@/views/mealsManage/ShopOrdersManage.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.goods_order.datagrid'
      }
    }, {
      path: '/ExpenseQRcode',
      name: '消费二维码',
      component: () => import('@/views/mealsManage/ExpenseQRcode.vue'),
      meta: {
        requireAuth: true,
        parent: '用餐管理',
        enterAuth: true,
        authority: 'b.consume_qrcode.datagrid'
      }
    }
    ]
  },

  //账户管理
  {
    path: '/accountManage',
    name: '账户管理',
    component: () => import('@/views/CommonSeconRouerview.vue'),
    meta: {
      requireAuth: true,
      parent: '账户管理',
      icon: "pay-circle",
      show: true
    },
    children: [
      {
        path: '/AccountRecharge',
        name: '账户充值',
        component: () => import('@/views/accountManage/AccountRecharge.vue'),
        meta: {
          requireAuth: true,
          parent: '账户管理',
          enterAuth: true,
          authority: 'b.wallet.datagrid'
        }
      },
      {
        path: '/AccountDetail',
        name: '账户明细',
        component: () => import('@/views/accountManage/AccountDetail.vue'),
        meta: {
          requireAuth: true,
          parent: '账户管理',
          enterAuth: true,
          authority: 'b.bill.datagrid'
        }
      },
    ]
  },

  //系统设置
  {
    path: '/systemConfig',
    name: '拓展功能',
    component: () => import('@/views/CommonSeconRouerview.vue'),
    meta: {
      requireAuth: true,
      parent: '拓展功能',
      icon: "appstore",
      show: true
    },
    children: [{
      path: '/NoticesManage',
      name: '公告管理',
      component: () => import('@/views/systemConfig/NoticesManage.vue'),
      meta: {
        requireAuth: true,
        parent: '拓展功能',
        enterAuth: true,
        authority: 'b.notice.datagrid'
      }
    }, {
      path: '/CookBookPicUpload',
      name: '菜谱图片',
      component: () => import('@/views/systemConfig/CookBookPicUpload.vue'),
      meta: {
        requireAuth: true,
        parent: '拓展功能',
        enterAuth: true,
        authority: 'b.menu_img.edit'
      }
    }, {
      path: '/HomeSwiperUpload',
      name: '首页幻灯片',
      component: () => import('@/views/systemConfig/HomeSwiperUpload.vue'),
      meta: {
        requireAuth: true,
        parent: '拓展功能',
        enterAuth: true,
        authority: 'b.slide.datagrid'
      }
    }, {
      path: '/DeviceConnection',
      name: '设备连接',
      component: () => import('@/views/systemConfig/DeviceConnection.vue'),
      meta: {
        requireAuth: true,
        parent: '拓展功能',
        enterAuth: true,
      }
    }, {
      path: '/Questionnaire',
      name: '问卷调查',
      component: () => import('@/views/expandApp/Questionnaire.vue'),
      meta: {
        requireAuth: true,
        parent: '拓展功能',
        enterAuth: true,
        moduleId: 66,
        authority: 'b.questionnaire.datagrid'
      }
    },
    {
      path: '/TaRenDaiBaoCan',
      name: '他人代报餐',
      component: () => import('@/views/expandApp/TaRenDaiBaoCan.vue'),
      meta: {
        requireAuth: true,
        parent: '拓展功能',
        enterAuth: true,
        moduleId: 67,
        authority: 'b.proxy_order.datagrid'
      }
    }
    ]
  },



  //经营报表模块
  {
    path: '/operatingStatement',
    name: '经营报表',
    component: () => import('@/views/CommonSeconRouerview.vue'),
    meta: {
      requireAuth: true,
      parent: '经营报表',
      icon: 'bar-chart',
      show: true
    },
    children: [
      /*
    {
      path: '/UserAccountReport',
      name: '用户账户报告',
      component: () => import('@/views/operatingStatement/UserAccountReport.vue'),
      meta: {
        requireAuth: true,
        parent: '经营报表',
        enterAuth: true,
        authority: 'b.wallet_report'
      }
    },*/
      {
        path: '/UserConsumeReport',
        name: '用户消费报告',
        component: () => import('@/views/operatingStatement/UserConsumeReport.vue'),
        meta: {
          requireAuth: true,
          parent: '经营报表',
          enterAuth: true,
          authority: 'b.bill_report'
        }
      },
      {
        path: '/CanteenOperationReport',
        name: '食堂经营报告',
        component: () => import('@/views/operatingStatement/CanteenOperationReport.vue'),
        meta: {
          requireAuth: true,
          parent: '经营报表',
          enterAuth: true,
          authority: 'b.canteen_report'
        }
      },
      /*
      {
        path: '/TimeMealStatus',
        name: '时段就餐统计',
        component: () => import('@/views/operatingStatement/TimeMealStatus.vue'),
        meta: {
          requireAuth: true,
          parent: '经营报表',
          enterAuth: true,
          authority: 'b.meal_report'
        }
      },*/
      {
        path: '/NoMealPersons',
        name: '未实际就餐统计',
        component: () => import('@/views/operatingStatement/NoMealPersons.vue'),
        meta: {
          requireAuth: true,
          parent: '经营报表',
          enterAuth: true,
          authority: 'b.meal_report_absent'
        }
      },
      {
        path: '/FirstOfferStatus',
        name: '首份优惠统计',
        component: () => import('@/views/operatingStatement/FirstOfferStatus.vue'),
        meta: {
          requireAuth: true,
          parent: '经营报表',
          enterAuth: true,
          authority: 'b.discount_report'
        }
      },
    ]
  },

  //  单位管理模块（仅超级管理员可见）
  {
    path: '/institutionsManage',
    name: '单位管理',
    component: () => import('@/views/CommonSeconRouerview.vue'),
    meta: {
      requireAuth: true,
      parent: '单位管理',
      icon: "hdd",
      show: false
    },
    children: [{
      path: '/InstitutionsInfos',
      name: '单位信息',
      component: () => import('@/views/institutionsManage/InstitutionsInfos.vue'),
      meta: {
        requireAuth: true,
        parent: '单位管理',
        enterAuth: true,
        authority: 'b.canteen.edit',
      }
    },

    {
      path: '/AuditAccountManage',
      name: '审核账号管理',
      component: () => import('@/views/institutionsManage/AuditAccountManage.vue'),
      meta: {
        requireAuth: true,
        parent: '单位管理',
        enterAuth: true,
        authority: 'b.auditor.datagrid',
      }
    },
    {
      path: '/VerificationModeSwitch',
      name: '其他设置',
      component: () => import('@/views/institutionsManage/VerificationModeSwitch.vue'),
      meta: {
        requireAuth: true,
        parent: '单位管理',
        enterAuth: true,
        authority: 'b.canteen_config.edit',
      }
    },
      /*
      {
        path: '/ReplaceApplyMealManage',
        name: '代报餐管理',
        component: () => import('@/views/institutionsManage/ReplaceApplyMealManage.vue'),
        meta: {
          requireAuth: true,
          parent: '单位管理',
          enterAuth: true,
          moduleId: 64
        }
      }*/
    ]
  },
  {
    path: '/miniapp',
    name: '微信小程序',
    component: () => import('@/views/CommonSeconRouerview.vue'),
    meta: {
      requireAuth: true,
      parent: '微信小程序',
      icon: "wechat",
      show: false
    },
    children: [
      {
        path: '/miniapp/index',
        name: '授权绑定',
        component: () => import('@/views/miniapp/index.vue'),
        meta: {
          authority: 'b.app_info.edit',
          requireAuth: true,
          parent: '微信小程序',
          show: true
        },
      },
      {
        path: '/miniapp/wxpay',
        name: '微信支付',
        component: () => import('@/views/miniapp/wxpay.vue'),
        meta: {
          authority: 'b.pay_config.edit',
          requireAuth: true,
          parent: '微信小程序',
          icon: "wechat",
          show: true
        },
      }
    ]
  },


  {
    path: '/miniapp/bind',
    name: '绑定小程序',
    component: () => import('@/views/miniapp/bind.vue'),
    meta: {
      parent: '绑定小程序',
      icon: "wechat",
      hidden: true
    },
  }
  ]
},
{
  path: '/easyLogin',
  name: 'easyLogin',
  component: easyLogin,
  meta: {
    requireAuth: false
  }
},
{
  path: '/tips',
  name: 'tips',
  component: () => import('@/views/errPage/tips.vue'),
  meta: {
    requireAuth: false
  }
},
{
  name: '404',
  path: '/404',
  component: () => import('@/views/errPage/index.vue')
}, {
  path: '*',
  redirect: '/404'
}
]

//start:往除了首页(没有子模块)，经营报表，单位管理之外的每个模块路由.meta中添加由接口返回来的对应模块权限的moduleId
//ps:经营报表，单位管理模块下的模块id已经与后端约定好且模块的moduleId在此页面路由中写死
let addModuleId = (useAuth) => {
  routes[1].children.forEach(element => {
    if (element.name != "首页" && element.name != "单位管理" && element.name != "拓展应用" && element.name != "更多功能及硬件") {
      element.children.forEach(item => {
        let indexOfUseAuth = util.findIndex(item.name, useAuth)
        item.meta.moduleId = useAuth[indexOfUseAuth] ? useAuth[indexOfUseAuth].id : ''
      })
    }
  })
}
//end

//埋点请求方法
let sensorsAnalyticsFn = function (p) {
  let id = p.id, obj = { platform: p.platform };
  sensorsAnalytics(id, obj).then(res => {
    // console.log('埋点请求成功:' + res)
  }).catch(err => {
    // console.log('埋点请求失败:' + err)
  })
}



let router = new VueRouter({
  mode: 'history',
  routes
})



router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem('token')

  if (token) {
    // start 在首页和经营报表模块下收起左侧导航栏,其他要展开
    if (to.path === '/Dashboard' || to.path === '/UserAccountReport' || to.path === '/UserConsumeReport' || to.path === '/CanteenOperationReport') {
      store.commit('CHANGE_COLLAPSED_TRUE')
    }
    // else{
    //   store.commit('CHANGE_COLLAPSED_FALSE')
    // }
    //end
    await store.dispatch("GET_ME")

    if (to.path === "/Dashboard" || to.path === '/easyLogin' || to.path === '/Renew') {
      next()
    } else if (to.path === "/login") {
      next({
        path: '/Dashboard'
      })
    } else {
      next();
    }

  } else {

    if (to.path === '/login' || to.path === '/easyLogin') {
      next()
    } else {
      return next({
        path: '/login'
      })
    }
  }

})

export default router